export default {
  regexBold: /^\*(.*)\*$/g, // *I am bold*
  regexItalic: /^\/(.*)\/$/g, // /I am italic/
  regexUnderline: /^_(.*)_$/g, // _I am underlined_
}
